import {
  FETCH_CANCEL_REASONS,
  FETCH_CANCEL_REASONS_SUCCESS,
  FETCH_CANCEL_REASONS_FAILED,
  EDIT_CANCELLATION_REASON
} from "../store/types";

import {
  cloud_function_server_url,
  language,
} from '../../config';

const END_POINT = `${cloud_function_server_url}/cancel-reasons`;

export const fetchCancelReasons = () => (dispatch) => (firebase) => {

  const {
    cancelreasonRef
  } = firebase;

  dispatch({
    type: FETCH_CANCEL_REASONS,
    payload: null,
  });

  fetch(`${END_POINT}/fetch-reasons`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      const data = response.data;
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i].label);
      }
      dispatch({
        type: FETCH_CANCEL_REASONS_SUCCESS,
        payload: {
          simple: arr,
          complex: data
        }
      });
    }).catch(error => {
      console.log("fetch user error", error)
      dispatch({
        type: FETCH_CANCEL_REASONS_FAILED,
        payload: language.no_cancel_reason,
      });
    });

  // cancelreasonRef.on("value", (snapshot) => {
  //   if (snapshot.val()) {
  //     let data = snapshot.val();
  //     let arr = [];
  //     for (let i = 0; i < data.length; i++) {
  //       arr.push(data[i].label);
  //     }
  //     dispatch({
  //       type: FETCH_CANCEL_REASONS_SUCCESS,
  //       payload: {
  //         simple: arr,
  //         complex: snapshot.val()
  //       }
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_CANCEL_REASONS_FAILED,
  //       payload: language.no_cancel_reason,
  //     });
  //   }
  // });
};

export const addCancellationReason = (reasons, method) => (dispatch) => (firebase) => {
  const {
    cancelreasonRef
  } = firebase;

  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });

  fetch(`${END_POINT}/add-reason`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ reason: reasons })
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("addCancellationReason", response);
      fetchCancelReasons()(dispatch)(firebase)
    }).catch(error => {
      console.log("addCancellationReason error", error)
    });
}

export const editCancellationReason = (reasons, method) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });

  fetch(`${END_POINT}/update-reason/${reasons._id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ reason: reasons.label })
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("editCancellationReason", response);
      fetchCancelReasons()(dispatch)(firebase)
    }).catch(error => {
      console.log("editCancellationReason error", error)
    });
}

export const deleteCancellationReason = (id, method) => (dispatch) => (firebase) => {

  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });

  fetch(`${END_POINT}/delete-reason/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("deleteCancellationReason", response);
      fetchCancelReasons()(dispatch)(firebase)
    }).catch(error => {
      console.log("deleteCancellationReason error", error)
    });
}

